// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton___I62O","unreadBadge":"styles_unreadBadge__1t03P","modalContent":"styles_modalContent__3csWq","modal":"styles_modal__35j8j"};